module.exports = __webpack_public_path__ + "img/transform_pdf.5fbcef80.svg";